import { useState } from "react";
import { toast } from "sonner";
import { Eyebrow } from "@/components/shared";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Mail, MessageSquare } from "lucide-react";

export default function Contact() {
  const [sent, setSent] = useState(false);
  const submit = (e) => { e.preventDefault(); setSent(true); toast.success("Thanks — we'll be in touch shortly."); };
  return (
    <div className="mx-auto max-w-4xl px-4 py-20 sm:px-6 lg:px-8">
      <Eyebrow>Contact</Eyebrow>
      <h1 className="font-display text-4xl font-extrabold tracking-tight text-slate-50">Talk to the ZettaKeep team.</h1>
      <p className="mt-4 max-w-xl text-slate-400">Questions about deployment, MSP pricing, or migrating an existing PBS? Send us a message.</p>
      <div className="mt-10 grid gap-8 md:grid-cols-[1fr_1.2fr]">
        <div className="space-y-4">
          <div className="flex items-center gap-3 text-slate-300"><Mail className="h-5 w-5 text-cyan-400" /> sales@zettakeep.com</div>
          <div className="flex items-center gap-3 text-slate-300"><MessageSquare className="h-5 w-5 text-cyan-400" /> Existing customers: open a support ticket in-app</div>
        </div>
        {sent ? (
          <div className="rounded-2xl border border-emerald-500/30 bg-emerald-500/5 p-8 text-emerald-200">Message received. We'll reply to your email soon.</div>
        ) : (
          <form onSubmit={submit} className="space-y-4 rounded-2xl border border-slate-800 bg-slate-900/40 p-6" data-testid="contact-form">
            <Input required placeholder="Your name" data-testid="contact-name" className="bg-slate-950 border-slate-700" />
            <Input required type="email" placeholder="Work email" data-testid="contact-email" className="bg-slate-950 border-slate-700" />
            <Textarea required placeholder="How can we help?" rows={5} data-testid="contact-message" className="bg-slate-950 border-slate-700" />
            <button className="w-full rounded-lg bg-cyan-400 py-3 font-semibold text-[#06080D] hover:bg-cyan-300" data-testid="contact-submit">Send message</button>
          </form>
        )}
      </div>
    </div>
  );
}
